/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
};

/**
 * 存储sessionStore
 */
export const setSessionStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
};
/**
 * 获取sessionStore
 */
export const getSessionStore = name => {
    if (!name) return;
    return window.sessionStorage.getItem(name);
};

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
export const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
};
/**
 * 设置cookie
 */
export const setCookie = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    document.cookie = name+'='+content
};

/**
 * 获取cookie
 */
export const getCookie = (name) => {
    var arr;
    var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
};
export const isWeiXin = () => {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    let ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    // return ua.indexOf('micromessenger') !== -1;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
    // return (/MicroMessenger/.test(ua));
};

export const isali = () => {
    //判断是否支付宝浏览器打开
    let ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('alipay') !== -1;
    // return (/AlipayClient/.test(ua))
};
export const ismpbank = () => {
    //判断是否招行app打开 8
    let ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('mpbank') !== -1;
};

export const isYizhifu = () => {
    //判断是否翼支付
    let ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('bestpay') !== -1;
};
// 判断一网通
export const isMpbank = () => {
  let ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('mpbank') !== -1;
};
// 判断IOS
export const isIOS = () => {
    return (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent));
};
// 判断安卓
export const isAnZhuo = () => {
    return (/(Android)/i.test(navigator.userAgent));
};
export const clientType = () => {
    if(isWeiXin()) {
        return 1
    } else if(isali()) {
        return 2
    }else if(isMpbank()){
        return 8
    }else{
        return 1
    }
};



// WEBPACK FOOTER //
// ./src/config/utils.js